import React, { Component } from 'react';
import { connect} from "remx";
import { Link } from "react-router-dom";

import authStore from "../../stores/auth";
import dataStore from "../../stores/data";
import broker from "../../utils/broker";
import avatar_img from '../../assets/img/user-icon.png';

class NavbarRight extends Component {

    signOut(){
        dataStore.setters.setDataExport([]);
        dataStore.setters.setDataKategori([]);
        dataStore.setters.setDataKategoriPer({});
        dataStore.setters.setDataPer({});
        dataStore.setters.setDataPelanggan({});
        dataStore.setters.setDataPelangganId('');
        dataStore.setters.setDataKategoriId('');
        authStore.setters.setUser(null);
        window.localStorage.clear();
        broker.logout();   
    }

    changePassword(e) {
        e.preventDefault();

        dataStore.setters.setChangePassword(true)
    }

    render(){
        return(
            <div className="navbar-right">
                <div className="dropdown dropdown-profile">
                <a href="!#" className="dropdown-link" data-toggle="dropdown" data-display="static">
                    <div className="avatar avatar-sm"><img src={avatar_img} className="rounded-circle" alt="" /></div>
                </a>
                <div className="dropdown-menu dropdown-menu-right tx-13">
                <div className="avatar avatar-lg mg-b-15"><img src={avatar_img} className="rounded-circle" alt="" /></div>
                    <h6 className="tx-semibold mg-b-5">{(this.props.user) ? this.props.user.nama_lengkap : null}</h6>
                    <a href="#!" onClick={(e) => this.changePassword(e)} 
                    className="dropdown-item cursor-pointer mg-b-25 tx-12 tx-color-03"><i className="fa fa-edit mg-r-10"></i>Change Password</a>
                    <Link to='/' className="dropdown-item"><i className="fa fa-tachometer-alt mg-r-10"></i>Dashboard</Link>
                    <div className="dropdown-divider"></div>
                    {(this.props.user && this.props.user.role !== 'user') &&
                        <React.Fragment>
                            <Link to='/master/user' className="dropdown-item"><i className="far fa-hdd mg-r-10"></i>Data Master</Link>
                            <Link to='/traffic' className="dropdown-item"><i className="fa fa-traffic-light mg-r-10"></i>Data Traffic</Link>
                            <Link to='/pekerjaan' className="dropdown-item"><i className="fa fa-tools mg-r-10"></i>Data Pekerjaan</Link>
                            <div className="dropdown-divider"></div>
                            <Link to='/monitoring' className="dropdown-item"><i className="fa fa-chart-line mg-r-10"></i>Live Chart MRTG</Link>
                            <Link to='/laporan' className="dropdown-item"><i className="fa fa-chart-bar mg-r-10"></i>Static Monthly MRTG</Link>
                            <Link to='/laporan_pertanggal' className="dropdown-item"><i className="fa fa-chart-bar mg-r-10"></i>Static Bydate MRTG</Link>
                            <Link to='/map' className="dropdown-item"><i className="fa fa-map-marker-alt mg-r-10"></i>Map MRTG</Link>
                            <div className="dropdown-divider"></div>
                            <Link to='/download' className="dropdown-item"><i className="fa fa-file-download mg-r-10"></i>Download Laporan</Link>
                        </React.Fragment>
                    
                    }
                    {(this.props.user && this.props.user.role === 'user') &&
                        <React.Fragment>
                            <Link to='/monitoring' className="dropdown-item"><i className="fa fa-chart-bar mg-r-10"></i>Live Chart MRTG</Link>
                            <Link to='/monitoring_pertanggal' className="dropdown-item"><i className="fa fa-chart-bar mg-r-10"></i>Live Bydate MRTG</Link>
                            <div className="dropdown-divider"></div>
                            <Link to='/download' className="dropdown-item"><i className="fa fa-file-download mg-r-10"></i>Download Laporan</Link>
                        </React.Fragment>
                    }
                    <div className="dropdown-divider"></div>
                    <a href="#" className="dropdown-item" onClick={()=> this.signOut()}><i className="fa fa-sign-out-alt mg-r-10"></i>Keluar Aplikasi</a>
                </div>
                </div>
            </div>
        );
    }

}

function mapStateToProps(props) {
    return {
        user: authStore.getters.getUser(),
    }
}

export default connect(mapStateToProps)(NavbarRight);